import { createContext, useContext, type ReactNode } from 'react';
import type { HostAdminApi } from './api/client';
import type { AuthService, HostAdminUser } from './auth/auth';

export interface AppServices {
  readonly api: HostAdminApi;
  readonly auth: AuthService;
  readonly user: HostAdminUser;
}

const Ctx = createContext<AppServices | null>(null);

export function AppServicesProvider(props: { value: AppServices; children: ReactNode }) {
  return <Ctx.Provider value={props.value}>{props.children}</Ctx.Provider>;
}

export function useServices(): AppServices {
  const value = useContext(Ctx);
  if (!value) throw new Error('useServices must be used inside AppServicesProvider');
  return value;
}
